import { useMemo, useState } from 'react';
import { Button, Icon } from 'semantic-ui-react';
import Swal from 'sweetalert2';
import moment from 'src/services/moment_instance';
import reportService from 'src/services/api/reportService';
import { chPerm } from 'src/components/helpers';
import { DashboardFinanzaComponent } from './styles/DashboardFinanzaComponent';

const MONTHS_BACK = 60;

const buildMonthOptions = () => {
  const options = [];
  const current = moment().startOf('month');

  for (let i = 0; i < MONTHS_BACK; i++) {
    const month = current.clone().subtract(i, 'months');
    options.push({
      value: month.format('YYYY-MM'),
      label: month.format('MMMM YYYY'),
    });
  }

  return options;
};

const Financiero = () => {
  const monthOptions = useMemo(() => buildMonthOptions(), []);
  const [selectedMonth, setSelectedMonth] = useState(monthOptions[0]?.value || '');
  const [loading, setLoading] = useState(false);

  const downloadPaymentsReport = () => {
    if (!selectedMonth) {
      Swal.fire('Selecciona un mes para descargar el reporte.');
      return;
    }

    setLoading(true);

    reportService
      .getReport({
        URL: '/dashboard/paymentsReport',
        fileName: `Transacciones_${selectedMonth}.xlsx`,
        body: { month: selectedMonth },
      })
      .catch((error) => {
        if (error.response) {
          try {
            const decoded = JSON.parse(
              String.fromCharCode.apply(null, new Uint8Array(error.response.data))
            );
            Swal.fire(decoded.message || 'No se pudo descargar el reporte.');
          } catch (_) {
            Swal.fire('No se pudo descargar el reporte.');
          }
        } else {
          Swal.fire('No se pudo descargar el reporte.');
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <DashboardFinanzaComponent>
      <div className="finanzasContent">
        <h2 className="h2Title">Financiero</h2>

        {chPerm(['finances'], true) && (
          <div className="reportSection">
            <h3>Reporte de transacciones</h3>
            <p>Descarga las transacciones aprobadas de un mes en formato Excel.</p>

            <div className="filtersRow">
              <div className="field">
                <label htmlFor="payments-month">Mes</label>
                <select
                  id="payments-month"
                  className="inputs"
                  value={selectedMonth}
                  onChange={(e) => setSelectedMonth(e.target.value)}
                >
                  {monthOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>

              <Button
                className="downloadButton"
                onClick={downloadPaymentsReport}
                disabled={loading || !selectedMonth}
                loading={loading}
              >
                <Icon name="file excel outline" />
                Descargar transacciones
              </Button>
            </div>
          </div>
        )}
      </div>
    </DashboardFinanzaComponent>
  );
};

export default Financiero;
